import { jsx } from 'react/jsx-runtime';
import { Button } from '../button/Button.js';
import { MdDownload, MdOpenInNew, MdKeyboardArrowRight, MdArrowForward } from '../node_modules/react-icons/md/index.js';

function ActionCellContent(ctx) {
  const {
    column,
    row,
    table
  } = ctx;
  const colMeta = column.columnDef.meta;
  const {
    disableAction
  } = table.options.meta;
  const {
    actionIndicator,
    actionLabel,
    onAction
  } = colMeta;
  const resolvedAction = typeof actionIndicator === 'function' ? actionIndicator(row.original) : actionIndicator;
  const resolvedLabel = typeof actionLabel === 'function' ? actionLabel(row.original) : actionLabel;
  const actionDisabled = !!disableAction?.(row.original);
  const icon = indicatorToIcon[resolvedAction];
  if (!icon) {
    return null;
  }
  return /*#__PURE__*/jsx(Button, {
    icon: icon,
    iconOnly: true,
    disabled: actionDisabled,
    size: "compact",
    variant: "ui-control",
    onClick: () => onAction(row.original),
    "data-table-internal-input": true,
    children: resolvedLabel
  });
}
function isActionColumn(x) {
  return 'actionIndicator' in x;
}
const indicatorToIcon = {
  navigate: MdArrowForward,
  modal: MdKeyboardArrowRight,
  'open-in-new': MdOpenInNew,
  download: MdDownload,
  none: null
};

export { ActionCellContent, isActionColumn };
